module.exports = __webpack_public_path__ + "static/media/1_en.c1a6f90d.png";